import { render } from "./EntryPage.vue?vue&type=template&id=283a6ca3&lang=pug"
import script from "./EntryPage.vue?vue&type=script&lang=js"
export * from "./EntryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__